import { useState } from 'react';
import Card from '../../../../shared/Card';
import { Box, Flex } from '../../../../shared/layouts';
import DropdownIcon from 'imagesUwKluis/svg/dropdown.svg';

const Collapse = ({ title, openByDefault = true, children }) => {
  const [isOpen, setIsOpen] = useState(openByDefault);

  return (
    <Card
      p={'l'}
      paddingY={'m'}
      border={'none'}
      css={({ boxShadows }) => ({
        boxShadow: boxShadows.normal
      })}
    >
      <Flex
        onClick={() => setIsOpen(value => !value)}
        justifyContent={'space-between'}
        css={{ cursor: 'pointer' }}
      >
        <b>{title}</b>
        <DropdownIcon
          width="16px"
          height="16px"
          css={{alignSelf: 'center', ...(isOpen ? { transform: 'rotate(180deg)' } : {})}}
        />
      </Flex>
      {isOpen && (
        <Box mt={'l'} mb={'s'}>
          {children}
        </Box>
      )}
    </Card>
  );
};

export default Collapse;
